import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Navbar from "./navbar";
import Contact from "./Contact";
import Footer from "./Footer";
import homeImage from '../images/home-image.jpg';

const Home = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: '⚖️',
      title: 'Legal Consultation',
      description: 'Get instant AI-powered legal advice based on Pakistan Penal Code and Constitution',
      path: '/ask-lawyer',
      color: '#c9a961'
    },
    {
      icon: '📝',
      title: 'My Queries',
      description: 'View, edit, and manage all your legal queries and AI responses in one place',
      path: '/my-queries',
      color: '#8b7355'
    },
    {
      icon: '📋',
      title: 'Requirements',
      description: 'Explore functional and non-functional requirements of the LawBot system',
      path: '/requirements',
      color: '#c9a961'
    },
    {
      icon: '💬',
      title: 'Community Posts',
      description: 'Share your thoughts and read posts from other users in the community',
      path: '/all-posts',
      color: '#8b7355'
    }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main className="main-content">
        {/* Hero Section with Image */}
        <div style={{
          position: 'relative',
          height: '70vh',
          minHeight: '500px',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url(${homeImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}>
          <Container>
            <div style={{
              animation: 'fadeInUp 1s ease-out',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              <h1 style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 'clamp(2.5rem, 6vw, 4rem)',
                fontWeight: '700',
                color: '#c9a961',
                marginBottom: '1.5rem',
                textShadow: '2px 2px 8px rgba(0, 0, 0, 0.8)'
              }}>
                Welcome to LawBot
              </h1>
              <p style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
                color: '#f5f5f0',
                marginBottom: '2rem',
                lineHeight: '1.7',
                textShadow: '1px 1px 4px rgba(0, 0, 0, 0.8)'
              }}>
                AI-Powered Legal Intelligence for Pakistan
              </p>
              <p style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: 'clamp(0.95rem, 1.5vw, 1.1rem)',
                color: '#d4d4d4',
                maxWidth: '600px',
                margin: '0 auto 2.5rem',
                lineHeight: '1.8',
                textShadow: '1px 1px 4px rgba(0, 0, 0, 0.8)'
              }}>
                Access affordable legal consultation powered by artificial intelligence. 
                Get instant guidance based on Pakistani law, PPC, and Constitution.
              </p>
              <Button
                size="lg"
                onClick={() => navigate('/ask-lawyer')}
                style={{
                  padding: '0.875rem 2.5rem',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  background: 'linear-gradient(135deg, #c9a961 0%, #d4b56f 100%)',
                  border: 'none',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  color: '#000000',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #d4b56f 0%, #e4c57f 100%)';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #c9a961 0%, #d4b56f 100%)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.3)';
                }}
              >
                Ask AI Lawyer Now
              </Button>
            </div>
          </Container>
        </div>

        {/* Features Section */}
        <section style={{
          padding: '5rem 0',
          background: 'rgba(0, 0, 0, 0.5)'
        }}>
          <Container>
            <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
              <h2 style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 'clamp(2rem, 4vw, 2.8rem)',
                fontWeight: '600',
                color: '#c9a961',
                marginBottom: '1rem'
              }}>
                What We Offer
              </h2>
              <p style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: '1.1rem',
                color: '#d4d4d4',
                maxWidth: '700px',
                margin: '0 auto'
              }}>
                Explore our comprehensive legal services and community features
              </p>
            </div>

            <Row className="g-4">
              {features.map((feature, index) => (
                <Col key={index} md={6} lg={3}>
                  <Card
                    onClick={() => navigate(feature.path)}
                    style={{
                      height: '100%',
                    cursor: 'pointer',
                    transition: 'all 0.4s ease',
                    background: 'rgba(30, 30, 30, 0.9)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '12px'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.7)';
                      e.currentTarget.style.borderColor = 'rgba(201, 169, 97, 0.4)';
                      e.currentTarget.style.background = 'rgba(35, 35, 35, 0.95)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.6)';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                      e.currentTarget.style.background = 'rgba(30, 30, 30, 0.9)';
                    }}
                  >
                    <Card.Body style={{
                      padding: '2rem',
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        fontSize: '3.5rem',
                        marginBottom: '1.5rem'
                      }}>
                        {feature.icon}
                      </div>
                      <h4 style={{
                        fontFamily: "'Inter', sans-serif",
                        fontSize: '1.3rem',
                        fontWeight: '600',
                        color: feature.color,
                        marginBottom: '1rem'
                      }}>
                        {feature.title}
                      </h4>
                      <p style={{
                        fontFamily: "'Roboto', sans-serif",
                        fontSize: '0.95rem',
                        color: '#d4d4d4',
                        lineHeight: '1.7',
                        marginBottom: 0
                      }}>
                        {feature.description}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* About LawBot Section */}
        <section style={{
          padding: '5rem 0',
          background: 'rgba(0, 0, 0, 0.3)'
        }}>
          <Container>
            <Row className="align-items-center">
              <Col lg={6} className="mb-4 mb-lg-0">
                <h2 style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)',
                  fontWeight: '600',
                  color: '#c9a961',
                  marginBottom: '1.5rem'
                }}>
                  About LawBot
                </h2>
                <p style={{
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  lineHeight: '1.8',
                  marginBottom: '1.5rem'
                }}>
                  LawBot is an innovative AI-powered legal consultation platform designed to make 
                  legal guidance accessible to everyone in Pakistan. Our advanced system provides 
                  instant responses to legal queries based on the Pakistan Penal Code (PPC) and Constitution.
                </p>
                <p style={{
                  fontFamily: "'Roboto', sans-serif",
                  fontSize: '1rem',
                  color: '#d4d4d4',
                  lineHeight: '1.8',
                  marginBottom: '1.5rem'
                }}>
                  Whether you're in a remote area with limited access to legal services or seeking 
                  private consultation, LawBot bridges the gap between legal expertise and accessibility.
                </p>
              </Col>
              <Col lg={6}>
                <div style={{
                  background: 'rgba(30, 30, 30, 0.8)',
                  padding: '2.5rem',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                  <h4 style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: '#c9a961',
                    marginBottom: '1.5rem'
                  }}>
                    Why Choose LawBot?
                  </h4>
                  <ul style={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: '1rem',
                    color: '#d4d4d4',
                    lineHeight: '2',
                    paddingLeft: '1.5rem'
                  }}>
                    <li>24/7 instant legal consultation</li>
                    <li>Affordable and accessible to all</li>
                    <li>Based on Pakistani legal framework</li>
                    <li>Private and confidential consultations</li>
                    <li>Support for multiple legal areas</li>
                    <li>Track and manage your queries</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Legal Areas Section */}
        <section style={{
          padding: '5rem 0',
          background: 'rgba(0, 0, 0, 0.5)'
        }}>
          <Container>
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              <h2 style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)',
                fontWeight: '600',
                color: '#c9a961',
                marginBottom: '1rem'
              }}>
                Legal Areas We Cover
              </h2>
              <p style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: '1.05rem',
                color: '#d4d4d4'
              }}>
                Get expert AI guidance across various legal domains
              </p>
            </div>

            <Row className="g-4">
              {['Family Law', 'Criminal Defense', 'Business Law', 'Estate Planning', 'Civil Rights', 'Tax Law', 'Immigration Law', 'General Legal'].map((area, index) => (
                <Col key={index} sm={6} lg={3}>
                  <div style={{
                    background: 'rgba(30, 30, 30, 0.8)',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(201, 169, 97, 0.15)';
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'rgba(201, 169, 97, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(30, 30, 30, 0.8)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                  }}>
                    <p style={{
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: '1rem',
                      fontWeight: '500',
                      color: '#c9a961',
                      marginBottom: 0
                    }}>
                      {area}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
